$ = jQuery.noConflict()

$(document).ready(function () {
  const $items = $('[data-mega]')
  if (!$items.length) return

  // Toggle on click (mobile + keyboard)
  $items.find('.ligo-nav__trigger').on('click', function (e) {
    e.preventDefault()
    const $parent = $(this).closest('[data-mega]')
    const isOpen = $parent.hasClass('is-open')
    $items.removeClass('is-open').find('.ligo-nav__trigger').attr('aria-expanded', 'false')
    if (!isOpen) {
      $parent.addClass('is-open')
      $(this).attr('aria-expanded', 'true')
    }
  })

  // Close on outside click (desktop)
  $(document).on('click', function (e) {
    if (!$(e.target).closest('[data-mega]').length) {
      $items.removeClass('is-open').find('.ligo-nav__trigger').attr('aria-expanded', 'false')
    }
  })

  // Close on Escape
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape') {
      $items.removeClass('is-open').find('.ligo-nav__trigger').attr('aria-expanded', 'false')
    }
  })

  // Close mega when a mega link is clicked (anchor navigation)
  $items.find('.ligo-mega__item, .ligo-mega__cta-btn').on('click', function () {
    $items.removeClass('is-open').find('.ligo-nav__trigger').attr('aria-expanded', 'false')
  })
})
